import { useMemo } from "react";
import { useAllFranchisees } from "../Franchisee/useAllFranchisees.ts";
import { TeacherRole, TeacherTag } from "../gql/graphql.ts";

export function useOnboardingLiveConductors() {
  const { franchisees, loading } = useAllFranchisees();
  return useMemo(() => {
    const nameById = new Map(
      franchisees.map((f) => [f.id, `${f.givenName} ${f.familyName}`]),
    );
    const conductors = franchisees
      .filter((f) => f.tags.includes(TeacherTag.OnboardingLive))
      .map((f) => ({
        id: f.id,
        name: f.roles.includes(TeacherRole.Teacher)
          ? `${f.givenName} ${f.familyName}`
          : `${f.givenName} ${f.familyName} (Staff Norma)`,
      }));
    return {
      conductors,
      teacherNameOf: (teacherId?: string | null): string =>
        teacherId ? (nameById.get(teacherId) ?? teacherId) : "-",
      loading,
    };
  }, [franchisees, loading]);
}
